import { Card, H2, P, Space } from '@dnb/eufemia';
import { ApiType } from '@portals/shared/portal/ApiDto';
import { useOutletContext } from 'react-router-dom';

import ScopeCard from '@/pages/profile/apps/application/components/ScopeCard';

import { ApiProviderPageOutletContext } from '../..';
import RequestScopeDeletion from '../ScopeRequestSection/RequestScopeDeletion';

export default function ScopesSection() {
  const { api, mutate } = useOutletContext<ApiProviderPageOutletContext>();

  const isEvent = api.type === ApiType.EVENT;

  return (
    <Card direction="vertical">
      <H2 bottom="small">Scopes</H2>
      {api.scopes && api.scopes.length > 0 ? (
        api.scopes?.map((scope, index) => (
          <Space key={scope.id} stretch top={index === 0 ? 0 : 'small'}>
            <ScopeCard
              deleteAction={
                isEvent ? undefined : (
                  <RequestScopeDeletion apiSlug={api.slug} onSuccess={mutate} scopeName={scope.name} />
                )
              }
              environments={[]}
              scopeDescription={scope.description}
              scopeId={scope.id}
              scopeName={scope.name}
              showAccessSection={false}
            />
          </Space>
        ))
      ) : (
        <P>Scopes have not been created.</P>
      )}
    </Card>
  );
}
